<template>
  <section class="section-shaped">
    <div :class="'shape bg-'+color+' shape-skew' + (alt ? '-alt':'-norm')"></div>
    <div class="container shape-container d-flex align-items-center pt-lg pb-0">
      <div class="col px-0">
        <div class="row justify-content-center align-items-center">
          <div class="col text-center">
            <div class="w-lg-50 mx-auto">
              <div class="lead text-white mt-4 mb-5 v0">{{ text }}</div>
            </div>
            <div v-if="buttonLink" class="btn-wrapper pb-lg">
              <router-link :to="buttonLink">
                <base-button class="badge-pill connect-gradient border-0 text-white px-sm">
                  <span class="display-4">{{ buttonText }}</span>
                </base-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "primary"
    },
    alt: {
      type: Boolean,
      default: false
    },
    buttonLink: {
      type: String,
      default: ""
    },
    buttonText: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    }
  }
};
</script>
